import React, { lazy, Suspense, useEffect } from "react";
import "./contactus.scss";
import ContactForm from "./ContactForm";
import { Link, useLocation } from "react-router-dom";
import telphone from "@/assets/telephone.png";
import mail from "@/assets/mail.png";
import locationImg from "@/assets/mdi_location.png";

import Facebook from "@/assets/Facebook.png";
import instagram from "@/assets/instagram.png";
import linkedIncircled from "@/assets/linkedIncircled.png";
import twitter_circle from "@/assets/twitter_circle.png";
import SEO from "./SEO";

const AppDownloadCard = lazy(
  () => import("../components/common/AppDownloadCard"),
);

const CustomerReviews = lazy(
  () => import("../components/payrolewebapp/CustomerReviews"),
);

const PayrollBanner = lazy(() => import("../components/common/PayrollBanner"));

const ModernizeHR = lazy(() => import("../components/common/ModernizeHR"));
import ContactSection from "./ContactSection";
const ContactUsPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      document.querySelector(location.hash)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  return (
    <>
      <SEO
        title="Contact Waggex | Payroll & Workforce Management Support"
        description="Get in touch with Waggex for payroll, attendance, and workforce management support. Our team is ready to help you get started fast."
        keywords="Contact Waggex, Payroll Software Support, HR Payroll Software Contact, Workforce Management Support, Payroll Software Help"
        canonical="https://www.waggex.com/contact-us"
      />
      {/* 
      <section id="ContactUsPage">
        <div className="container">
          <div className="top-section">
            <h1 className="text-enter font-roboto text-xl sm:text-3xl font-bold text-[#10324F]">
              Contact Us
            </h1>
            <p>Any Question or a Remarks? Just write us a message! </p>
          </div>
          <div className="contact-us">
            <div className="row">
              <div className="col-sm-12  col-lg-5">
                <div className="contact_us_left_side">
                  <h4 className="header   d-flex justify-content-center justify-content-lg-start">
                    Contact Information
                  </h4>
                  <p className="paragraph d-flex justify-content-center justify-content-lg-start">
                    Say something to Chat with us.
                  </p>

                  <ul className="list">
                    <li className="list-item">
                      <div className="row">
                        <div className="col-sm-12 col-lg-3 d-flex justify-content-center">
                          <div className="img-sec">
                            <img
                              fetchPriority="high"
                              src={telphone}
                              className="img-fluid"
                              alt="telephone icon"
                            />
                          </div>
                        </div>

                        <div className="col-sm-12 col-lg-9 d-flex justify-content-center justify-content-lg-start">
                          <p className="mt-4 mt-lg-0">91 - 8571913707 </p>
                        </div>
                      </div>
                    </li>

                    <li className="list-item">
                      <div className="row">
                        <div className="col-sm-12 col-lg-3 d-flex justify-content-center">
                          <div className="img-sec">
                            <img
                              src={mail}
                              alt="email"
                              fetchPriority="high"
                              className="img-fluid"
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-lg-9 d-flex justify-content-center justify-content-lg-start">
                          {" "}
                          <p className="mt-4 mt-lg-0">Info@waggex.com</p>
                        </div>
                      </div>
                    </li>

                    <li className="list-item">
                      <div className="row">
                        <div className="col-sm-12 col-lg-3 d-flex justify-content-center">
                          <div className="img-sec">
                            <img
                              src={locationImg}
                              fetchPriority="high"
                              alt="location"
                              className="img-fluid"
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-lg-9 d-flex justify-content-center justify-content-lg-start">
                          <p
                            className="mt-4 mt-lg-0"
                            style={{ textTransform: "capitalize" }}
                          >
                            {" "}
                            Phase 8-B, Industrial Area, Sector 74, Sahibzada
                            Ajit Singh Nagar, Punjab 140307
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>

                  <div className="social-media-logo d-flex justify-content-center justify-content-lg-center">
                    <ul>
                      <li>
                        <Link to="https://www.facebook.com/waggexx/">
                          <img
                            src={Facebook}
                            className="img-fluid"
                            fetchPriority="high"
                            alt="Facebook"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link to="https://www.instagram.com/waggexx/">
                          <img
                            src={instagram}
                            className="img-fluid"
                            fetchPriority="high"
                            alt="Instagram"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link to="https://www.linkedin.com/company/waggex/">
                          <img
                            src={linkedIncircled}
                            className="img-fluid"
                            fetchPriority="high"
                            alt="LinkedIn"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link to="https://x.com/waggexx">
                          <img
                            src={twitter_circle}
                            className="img-fluid"
                            fetchPriority="high"
                            alt="Twitter"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-lg-7">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <ContactSection />
      <Suspense fallback={null}>
        <CustomerReviews />
        {/* <PayrollBanner
          heading="Everything Your HR Team Needs. One Platform"
          description="Manage payroll, attendance, compliance, employee records, and workforce operations with greater accuracy, visibility, and control"
          buttonText=""
        /> */}
        <section className="w-full bg-[#d3e0eb] px-6 py-10">
          <div className="max-w-6xl mx-auto text-center mt-4 mb-4">
            <h2 className="text-[#10324F] text-xl sm:text-3xl font-roboto font-bold uppercase">
              Everything Your HR Team Needs. One Platform
            </h2>

            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Manage payroll, attendance, compliance, employee records, and
              workforce operations with greater accuracy, visibility, and
              control
            </p>

            <button
              className="mt-6 bg-[#10324F] text-white py-3 px-6 rounded-xl text-sm sm:text-lg shadow-lg hover:scale-[1.02] transition"
              onClick={() =>
                (window.location.href = "https://app.waggex.com/signup")
              }
            >
              Try Waggex Free | Book Demo
            </button>
          </div>
        </section>
        <AppDownloadCard />
        <ModernizeHR />
      </Suspense>
    </>
  );
};

export default ContactUsPage;
